import { get, post } from "../../../shared/data";

export const addBinToShipment = (locationCode) => {
    const payload = {
        locationCode,
    };

    return post("/binmgt/bins", payload);
};

export const getLocations = () => {
    return get("/binmgt/locations").then((locations) => {
        return locations.map((location) => {
            return {
                value: location.code,
                text: location.description,
            };
        });
    });
};

export const getBins = (shipmentKey) => {
    return get(`/receiving/shipments/${shipmentKey}/products`).then((products) => {
        return products.reduce((binList, product) => {
            if (!binList.includes(product.binTrackingNumber)) {
                binList.push(product.binTrackingNumber);
            }

            return binList;
        }, []);
    });
};

export const generateBinNumber = () => {
    return post("/binmgt/bins/generate", null);
};
